<template>
  <div v-if="loading">
    <v-col cols="12" v-if="loading">
      <v-sheet color="grey lighten-4" class="pa-3">
        <v-skeleton-loader type="article"></v-skeleton-loader>
      </v-sheet>
    </v-col>
  </div>

  <div
    v-else
    class="sub-request-card">
    <div
      v-for="subRequestType in subRequestTypes"
      :key="subRequestType.id"
      class="card"
      @click="$emit('select-case-request-type', subRequestType.id)"
    >
      <div class="card-content">
        <div class="card-body">
          <h6 class="category-name">
            <v-icon class="icon">
              mdi-file-document
            </v-icon>
            {{ getCategoryName(subRequestType.categoryId) }}
          </h6>
          <p class="request-name">
            {{ subRequestType.name }}
          </p>
          <span class="action-button">
            اختيار
            <v-icon class="icon">mdi-arrow-left</v-icon>
          </span>
        </div>
      </div>
    </div>
    <naj-no-data
      v-if="!loading"
      :has-data="subRequestTypes.length > 0"
    >
    </naj-no-data>
  </div>
</template>

<script>
export default {
  name: 'SubRequestsTypeCard',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    subRequestTypeCategory: {
      type: Array,
      required: false,
      default: () => [],
    },
    subRequestTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
    local: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    bankruptcyText() {
      return this.local && this.local.bankruptcy && this.local.bankruptcy.bankruptcy
        ? this.local.bankruptcy.bankruptcy
        : 'Bankruptcy';
    },
    submitRequestText() {
      return this.local && this.local.common && this.local.common.submitRequest
        ? this.local.common.submitRequest
        : 'Submit Request';
    },
    subRequestTypeCategoryName() {
      return this.subRequestTypeCategory && this.subRequestTypeCategory.name ? this.subRequestTypeCategory.name : '';
    },
    hasSubCategory() {
      return !!(this.subRequestTypeCategory && this.subRequestTypeCategory.name);
    },
  },
  methods: {
    getCategoryName(categoryId) {
      const category = this.subRequestTypeCategory?.find(c => c.id === categoryId);
      return category ? category.name : '';
    },
  },
};
</script>

<style scoped>
.sub-request-card {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  justify-content: flex-start;
  align-items: stretch;
}

.card {
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #f0f0f0;
  width: 280px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  margin: 1px 0 10px 0;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  border-color: #e0e7ff;
  background-color: #00ad68;
}

.card:hover .category-name,
.card:hover .request-name,
.card:hover .action-button,
.card:hover .icon {
  color: white !important;
}

.card-content {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.category-name {
  font-size: 0.85rem;
  color: #64748b;
  font-weight: bold;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.request-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: auto;
  line-height: 1.4;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.icon {
  color: #00ad68;
  font-size: 20px;
}

.action-button {
  align-self: flex-end;
  margin-top: 16px;
  color: #00ad68;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s ease;
}

/* Responsive */
@media (max-width: 768px) {
  .sub-request-card {
    justify-content: center;
  }

  .card {
    width: 100%;
    max-width: 350px;
  }
}

.category-name:empty {
  display: none;
}
</style>
